import gql from 'graphql-tag';

export default gql`
  mutation adminDeleteAllocationEntry($allocationEntryId: ID!) {
    adminDeleteAllocationEntry(allocationEntryId: $allocationEntryId)
  }
`;
